import Vue from 'vue'

import api from '../../api'

export default {
  state: {
    inventory: {}
  },
  getters: {
    bridgeInventory(state) {
      return Object.values(state.inventory)
    },
    getInventoryBridgeBySerial(state) {
      return (serialNumber) => state.inventory[serialNumber]
    },
    getBridgeQr(state, getters) {
      return (serialNumber) => getters.getInventoryBridgeBySerial(serialNumber).qr
    }
  },
  mutations: {
    setBridgeInventory(state, { inventory }) {
      state.inventory = inventory
    },
    setBridgeInventoryIndividual(state, { serial_number, bridge }) {
      Vue.set(state.inventory, serial_number, bridge)
    },
    setBridgeQr(state, { bridge, qr }) {
      Vue.set(bridge, 'qr', qr)
    },
    setAvailableBridges(state, { bridge, available }) {
      Vue.set(bridge, 'available', available)
    }
  },
  actions: {
    async fetchBridgeInventory({ commit }) {
      const response = await api.get('inventory/bridge')
      const inventory = response.data

      commit('setBridgeInventory', { inventory })
    },
    async shipBridge({ commit }, { id, serial_number }) {
      const response = await api.patch(`inventory/bridge/${id}/ship`)
      const bridge = response.data

      commit('setBridgeInventoryIndividual', { serial_number, bridge })
      return response
    },
    async unshipBridge({ commit }, { id, serial_number }) {
      const response = await api.patch(`inventory/bridge/${id}/unship`)
      const bridge = response.data

      commit('setBridgeInventoryIndividual', { serial_number, bridge })
      return response
    },
    async fetchBridgeQr({ commit }, bridge) {
      if(bridge.qr) {
        return bridge.qr
      }

      const response = await api.get(`inventory/bridge/${bridge.id}/qr`)
      const qr = response.data

      commit('setBridgeQr', { bridge, qr })
      return qr
    },
    async createBridge({ commit }, bridge) {
      bridge.is_virtual = +bridge.is_virtual

      const response = await api.post('inventory/bridge', bridge)
      bridge = response.data.bridge

      commit('setBridgeInventoryIndividual', { serial_number: bridge.serial_number, bridge })
    },
    async connectBridgeToCloud({ commit }, { id, serial_number }) {
      const response = await api.patch(`inventory/bridge/${id}/cloud`)
      const bridge = response.data.bridge

      commit('setBridgeInventoryIndividual', { serial_number, bridge })
      return response
    },
    async fetchAvailableBalenaBridges({ getters, commit }, { id, serial_number }) {
      const response = await api.get(`inventory/bridge/${id}/balena`)
      const available = response.data
      const bridge = getters.getInventoryBridgeBySerial(serial_number)

      commit('setAvailableBridges', { bridge, available })
    },
    async connectBridgeToBalena({ commit }, { localBridge, balenaBridge }) {
      const response = await api.patch(`inventory/bridge/${localBridge.id}/balena`, {
        bridgeID: balenaBridge.id,
        bridgeUUID: balenaBridge.uuid
      })
      const bridge = response.data.bridge

      commit('setBridgeInventoryIndividual', { serial_number: localBridge.serial_number, bridge })
      return response
    }
  }
}